import React from "react";
import styles from "./videocall.module.scss";
//import Videocallimg from "../../../../styles/images/pic-4.png";
import Draggable from "react-draggable";
import { useSelector } from "react-redux";
import { profileDetails } from "../../../../models/model";
import { closeVideoRinging,getCookie } from "../../../../base/utils";

import axios from "axios";
import { config } from "../../../../base/constant";
import { updateMeetingRead, updateMeetingTotalBatch } from "../../../../base/meetingService/apiService";
import store from "../../../../context/store/store";
import { Types } from "../../../../context/action/action";
export default function VideoCallScreenRight() {
  let { meetingDetails}: profileDetails = useSelector((state: any) => state.profileReducer);
  
  //const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  // const closePopup = () => {
  //   const userInfo:any =Cookie.get();
  //   if(loginDetails){
  //     const userDetails = loginDetails.userdetails;
  //     const socketChat = new SocketChatService(userDetails?.sip_login_id,userDetails?.domain_id);
  //     socketChat.RingingNotificationStopStatus({meetingId:meetingDetails.meetingId}); 
  //   }
  //   closeVideoRinging();
  // }


 const AcceptVideo = (param:any) => {
  let token: any = getCookie("ssoToken");
  var authkey = {
    "Content-Type": "application/json",
    Authorization: token
  };
  let urlParam:any = "";
  if(param === "joined"){
    urlParam = `${config().MEET_RESTAPI_URL}/joined/${meetingDetails.meetingId}`
    let replaced_url:any= meetingDetails.inviteUrl?.includes("stagemeet") ?
    `${meetingDetails.inviteUrl}?type=meetnow` : `${meetingDetails.inviteUrl?.replace('meet.unifiedring', 'meet.worktual')}?type=meetnow`;
    window.open(replaced_url, '_blank');
    closeVideoRinging();
    
  }else {
    urlParam =`${config().MEET_RESTAPI_URL}/rejected/${meetingDetails.meetingId}` 
    closeVideoRinging();
  }
 axios
    .get(urlParam, { headers: authkey })
    .then((response: any) => {
      if (response.data && response.data.statusCode === 200) {
       console.log("ringing notification");
       store.dispatch({
        type: Types.VIDEOMEET_COUNT_STATUS,
        payload: {
          meetingCountStatus:true
        }
      })
       updateMeetingRead(meetingDetails?.meetingId);
      }
    });
};

  return (
    <>
      <Draggable bounds="parent"><div className={styles.videocallScreenright}>
        <div className={styles.dialpadHeader}>
          <div className={styles.calltiming}><p>Video Calling…<span>HD</span></p></div>
        </div>
        <div className={styles.videocallimguserbdy}>
          {/* <div className={styles.videocallimg}>
            <img src={Videocallimg} alt="videoimg" />
          </div> */}
          <div className={styles.videocallimgUSer}>
            <span>{meetingDetails?.hostDetails?.name?.charAt(0)}</span>
          </div>
          <div className={styles.callpadbottom}>
            <div className={styles.leftcontent}>
              <h4>{meetingDetails?.hostDetails?.name}</h4>
              <p className={styles.Exenum}>is inviting to the video meeting</p>
            </div>
            <ul>
              <li onClick={()=>AcceptVideo('')}> <span className={`icon_receiverfill ${styles.videoicon}`}></span></li>
              <li onClick={()=>AcceptVideo('joined')}> <span className={`icon_meet ${styles.callicon}`}></span></li>
            </ul>
          </div>
        </div>
      </div>
      </Draggable>
    </>
  );
};